import { useState, useEffect, useCallback } from 'react';
import { HistoryManager } from '../utils/historyUtils';
export const useHistoryManager = () => {
    const [history, setHistory] = useState([]);
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [showPasswordInput, setShowPasswordInput] = useState(false);
    const [password, setPassword] = useState("");
    const [isCloudStorageEnabled, setIsCloudStorageEnabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [editingHistoryId, setEditingHistoryId] = useState(null);
    // 初始化历史管理器和加载历史记录
    useEffect(() => {
        const initializeHistory = async () => {
            // 初始化云存储状态
            HistoryManager.initialize();
            console.log('useHistoryManager: 初始化历史管理器');
            // 获取历史记录（如果启用了云存储，会自动从云端加载）
            const history = await HistoryManager.getHistoryWithCloudSync();
            setHistory(history);
            setIsCloudStorageEnabled(HistoryManager.isCloudStorageEnabled());
            console.log('useHistoryManager: 历史记录已加载，数量:', history.length);
        };
        initializeHistory();
    }, []);
    // 处理密码提交
    const handlePasswordSubmit = useCallback(async () => {
        if (!password.trim())
            return;
        setIsLoading(true);
        try {
            console.log('useHistoryManager: 提交密码启用云存储');
            const success = await HistoryManager.enableCloudStorage(password);
            if (success) {
                console.log('useHistoryManager: 云存储启用成功，重新加载历史记录');
                setIsCloudStorageEnabled(true);
                setShowPasswordInput(false);
                setPassword("");
                // 刷新历史记录（从云端加载）
                const history = await HistoryManager.getHistoryWithCloudSync();
                setHistory(history);
                console.log('useHistoryManager: 历史记录已刷新，数量:', history.length);
            }
            else {
                alert("密码错误，请重试");
            }
        }
        catch (error) {
            console.error("启用云存储失败:", error);
            alert("启用云存储失败，请稍后再试");
        }
        finally {
            setIsLoading(false);
        }
    }, [password]);
    // 处理历史记录保存
    const handleSaveHistory = useCallback(async (item) => {
        if (editingHistoryId) {
            // 如果正在编辑，更新现有记录
            await HistoryManager.updateHistory(editingHistoryId, item);
            // 重置编辑状态
            setEditingHistoryId(null);
        }
        else {
            // 如果不是编辑，创建新记录
            await HistoryManager.saveHistory(item);
        }
        setHistory(HistoryManager.getHistory());
    }, [editingHistoryId]);
    // 处理历史记录删除
    const handleDeleteHistory = useCallback(async (id) => {
        await HistoryManager.deleteHistory(id);
        setHistory(HistoryManager.getHistory());
    }, []);
    // 处理历史记录清空
    const handleClearHistory = useCallback(async () => {
        if (isCloudStorageEnabled) {
            alert("云存储已启用，无法清空历史记录");
            return;
        }
        if (confirm('确定要清空所有历史记录吗？')) {
            await HistoryManager.clearHistory();
            setHistory([]);
        }
    }, [isCloudStorageEnabled]);
    // 过滤历史记录
    const filteredHistory = history.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item.type === 'synastry' && item.person2?.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        `${item.year}-${item.month}-${item.day}`.includes(searchTerm));
    return {
        history: filteredHistory,
        showHistoryModal,
        setShowHistoryModal,
        searchTerm,
        setSearchTerm,
        showPasswordInput,
        setShowPasswordInput,
        password,
        setPassword,
        isCloudStorageEnabled,
        isLoading,
        editingHistoryId,
        setEditingHistoryId,
        handlePasswordSubmit,
        handleSaveHistory,
        handleDeleteHistory,
        handleClearHistory,
    };
};
